$component-class: 'sn-navbar-type-2';

.#{$component-class} {
  position: relative;
  width: 100%;
  z-index: 100;
  background-color: var(--color-neutral-white);

  &__container {
    display: flex;
    align-items: center;

    @include container;

    padding-top: var(--spacing-md);
    padding-bottom: var(--spacing-md);
    max-width: $sn-container-max-width;
  }

  &__logo-column {
    display: flex;
    align-items: center;
    padding: 0;
  }

  &__logo-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;

    svg {
      display: block;
    }
  }
}
